import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=32776bb2&scoped=true&lang=pug"
import script from "./ObjectInfo.vue?vue&type=script&lang=ts"
export * from "./ObjectInfo.vue?vue&type=script&lang=ts"
import style0 from "./ObjectInfo.vue?vue&type=style&index=0&id=32776bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32776bb2",
  null
  
)

export default component.exports